export const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL;
export const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN;
// const environment = process.env.REACT_APP_ENVIRONMENT;
export const VALIDATION_KEY = "TheCityGaurds@APP@852456753159_Key_P@$$w0rd";

export const YEARS = [
  1924, 1925, 1926, 1927, 1928, 1929, 1930, 1931, 1932, 1933, 1934, 1935, 1936,
  1937, 1938, 1939, 1940, 1941, 1942, 1943, 1944, 1945, 1946, 1947, 1948, 1949,
  1950, 1951, 1952, 1953, 1954, 1955, 1956, 1957, 1958, 1959, 1960, 1961, 1962,
  1963, 1964, 1965, 1966, 1967, 1968, 1969, 1970, 1971, 1972, 1973, 1974, 1975,
  1976, 1977, 1978, 1979, 1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988,
  1989, 1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001,
  2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014,
  2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024,
];

export const ACCEPTED_IMAGE_FORMATS = ["image/png", "image/jpeg", "image/jpg"];
export const ACCEPTED_GALLERY_IMAGE_FORMATS = [
  "image/png",
  "image/jpeg",
  "image/jpg",
];
export const ACCEPTED_FILE_FORMATS = [
  ...ACCEPTED_GALLERY_IMAGE_FORMATS,
  "application/pdf",
];

export const SHORT_MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const ACCEPTED_IMAGE_SIZE = 1936280;
export const ACCEPTED_FILE_SIZE = 536280;

export const FILNAME_REGEX = "^[0-9a-zA-Z_\\- ]+$";
export const RANDOM_ARRAY = [
  1924, 1925, 1926, 1927, 1928, 1929, 1930, 1931, 1932,
];

// Example Slate.js document structure
export const exampleSlateData = [
  {
    children: [
      {
        text: "Start writing your blog...",
      },
    ],
    type: "h1",
    id: "Pqy3BSGNKf",
  },
  {
    children: [
      {
        text: "Description for your blog",
      },
    ],
    type: "p",
    id: "6BIUvUm6Ii",
  },
];

export const exampleSlateData2 = [
  {
    children: [
      {
        text: "Start writing your blog...",
      },
    ],
    type: "h1",
    id: "Pqy3BSGNKf",
  },
  {
    children: [
      {
        text: "Description for your blog",
      },
    ],
    id: "JJ5aBVu_We",
  },
  {
    children: [
      {
        text: "",
      },
    ],
    type: "p",
    id: "aegG16znqg",
  },
];

export const coverDataList = [
  {
    id: crypto.randomUUID(),
    type: "img",
    children: [],
    properties: {
      content: "/images/box-logo.png",
    },
  },
  {
    id: crypto.randomUUID(),
    type: "header",
    children: [],
    properties: {
      content: "Blog _________",
    },
  },
  {
    id: crypto.randomUUID(),
    type: "subHeader",
    children: [],
    properties: {
      content: "Written by ________ for ________",
    },
  },
  {
    id: crypto.randomUUID(),
    type: "btn",
    children: [],
    properties: {
      content: "Start Reading Proposal",
      style: {
        textColor: "#000000",
        borderColor: "#000000",
        borderRadius: "0rem",
      },
    },
  },
  {
    id: crypto.randomUUID(),
    type: "bgColor",
    children: [],
    properties: {
      content: "#111111", // Default background color
    },
  },
  {
    id: crypto.randomUUID(),
    type: "bgImage",
    children: [],
    properties: {
      content: "", // Default: no background image
    },
  },
];

export const PEOPLE = [
  "{{company_name}}",
  "{{company_address}}",
  "{{company_phone}}",
  "{{company_email}}",
  "{{company_website}}",
  "{{company_logo}}",
  "{{company_mission}}",
  "{{company_vision}}",
  "{{company_values}}",
];

export const COMPANY_DATA = {
  company_name: "The City Guards",
  company_address: "123 Security Street, Guardville, GV 12345",
  company_phone: "+1 (555) 123-4567",
  company_email: "contact@thecityguards.com",
  company_website: "www.thecityguards.com",
  company_logo: "/images/company-logo.png",
  company_mission: [
    {
      type: "p",
      children: [
        {
          text: "To provide unmatched security solutions with integrity and professionalism",
          bold: true,
          color: "#000000",
        },
      ],
    },
  ],
  company_vision: [
    {
      type: "p",
      children: [
        {
          text: "To be the most trusted name in security services",
          italic: true,
        },
      ],
    },
  ],
  company_values: [
    {
      type: "p",
      children: [
        {
          text: "Integrity • Excellence • Dedication",
          bold: true,
          color: "#000066",
        },
      ],
    },
  ],
};

export const SnackBarSuccessMessage = "Data saved successfully";
export const SnackBarErrorMessage =
  "Oops! Something went wrong. Please try again.";
